/************
 Product Swiper
 ************/

// setup product swiper
const productSwiper = new Swiper(document.querySelector(".productVisualSwiper"), {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    pagination: {
        el: '#productVisualSwiperPag',
    },
    on: {
        slideChange: function () {
            // update the thumbnail active class
            const previousActive = document.querySelector(".productVisualThumbsSlide.active");
            previousActive.classList.remove("active");
            previousActive.removeAttribute("aria-current");

            const newActive = document.querySelectorAll(".productVisualThumbsSlide")[this.realIndex];
            newActive.classList.add("active");
            newActive.setAttribute("aria-current", "true");

            // announce the main image change to assistive tech
            const visualStatus = document.querySelector("#productVisualStatus");
            if (visualStatus) {
                const total = document.querySelectorAll(".productVisualThumbsSlide").length;
                visualStatus.textContent = `Showing image ${this.realIndex + 1} of ${total}`;
            }

            // pause all videos
            document.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                element.pause();
            });
        }
    }
});

// play video on slide play click
document.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productVisualSwiperSlide").querySelector("video");

        // remove play button if it hasn't already been removed
        this.querySelector(".productVisualSwiperSlidePlay")?.remove();

        // show controls
        video.controls = true;

        // play video
        video.play();
    });
});

// change slide on thumbnail click
document.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        productSwiper.slideTo(this.dataset.index - 1);
    });
});

// show "more images" indicators while the thumbnail rail has unscrolled content above/below
(function () {
    const thumbs = document.querySelector(".productVisualThumbs");
    const topIndicator = document.querySelector(".productVisualThumbsMore--top");
    const bottomIndicator = document.querySelector(".productVisualThumbsMore--bottom");
    if (!thumbs || !topIndicator || !bottomIndicator) {
        return;
    }

    function updateMoreIndicators() {
        const hasOverflow = thumbs.scrollHeight > thumbs.clientHeight + 1;
        const atTop = thumbs.scrollTop <= 1;
        const atBottom = thumbs.scrollTop + thumbs.clientHeight >= thumbs.scrollHeight - 1;
        topIndicator.classList.toggle("visible", hasOverflow && !atTop);
        bottomIndicator.classList.toggle("visible", hasOverflow && !atBottom);
    }

    thumbs.addEventListener("scroll", updateMoreIndicators);
    window.addEventListener("resize", updateMoreIndicators);
    updateMoreIndicators();

    // clicking an indicator scrolls the rail by roughly one visible page
    topIndicator.addEventListener("click", function () {
        thumbs.scrollBy({ top: -thumbs.clientHeight * 0.9, behavior: "smooth" });
    });
    bottomIndicator.addEventListener("click", function () {
        thumbs.scrollBy({ top: thumbs.clientHeight * 0.9, behavior: "smooth" });
    });
})();


/**************
 Product Variants
 ***************/

let quantity = 1;

// update active variant on input changes
document.querySelectorAll("#product input").forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct();
    });
})

// the best-discount plan input, used as a fallback when nothing is checked yet
function getDefaultPlanInput() {
    const targetId = document.querySelector(".subOptionHead")?.dataset.defaultPlanTarget;
    return targetId ? document.getElementById(targetId) : null;
}

// clicking the subscribe header selects the default (best-discount) plan
document.querySelector(".subOptionHead")?.addEventListener("click", function () {
    const input = getDefaultPlanInput();
    if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
    }
});

// update subscription-widget pricing for the current quantity/variant
function updateSubscriptionPricing() {
    const oneTimePriceEl = document.querySelector("#productControls .subOption:not(.subOption--subscribe) .subOptionPrice");
    if (oneTimePriceEl) {
        oneTimePriceEl.textContent = price(activeVariant.price * quantity);
    }

    // a real user selection, or the default plan as a preview while "one-time" is active
    const checkedPlan = document.querySelector("#productControls .subPlanInput:checked");
    const effectivePlan = checkedPlan || getDefaultPlanInput();

    const subPriceNowEl = document.querySelector("#productControls .subPriceNow");
    if (effectivePlan && subPriceNowEl) {
        let saveAmount = effectivePlan.dataset.savings;
        let perUnit = Math.round(activeVariant.price - (activeVariant.price * (saveAmount / 100)));
        subPriceNowEl.textContent = price(perUnit * quantity);
    }

    // only announce a plan the shopper actually chose, not the fallback preview
    const subStatus = document.querySelector("#subControlsStatus");
    if (checkedPlan && subStatus) {
        const planNameEl = checkedPlan.closest(".subFreqBtn")?.querySelector(".subFreqBtnName");
        const planName = planNameEl ? planNameEl.textContent.trim() : "Subscription";
        const priceNow = subPriceNowEl ? subPriceNowEl.textContent.trim() : "";
        subStatus.textContent = `${planName} selected, save ${checkedPlan.dataset.savings}%${priceNow ? `, ${priceNow} per order` : ""}`;
    }

    if (effectivePlan) {
        document.querySelectorAll("#productControls .subActivePct").forEach(function (element) {
            element.textContent = effectivePlan.dataset.savings;
        });
    }
}

updateSubscriptionPricing();

// update active variant
function updateProduct() {

    // update subscription widget pricing
    updateSubscriptionPricing();

    // check if the variant is in stock
    if (activeVariant.available) {
        document.querySelector("#productATC").disabled = false;
        document.querySelector("#productATC").textContent = "Add To Cart";
    } else {
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "Sold Out";
    }

    // update price
    document.querySelector("#productPriceNum").textContent = price(activeVariant.price);

    // check if selling plan selected
    const checkedPlanInput = document.querySelector("#productControls .subPlanInput:checked");
    if (checkedPlanInput) {
        // find selling plan
        let activeVariantPlan = activeVariant.selling_plan_allocations[0];
        const checkedPlanId = parseInt(checkedPlanInput.value, 10);

        // find the correct selling_plan_allocation
        for (let plan of activeVariant.selling_plan_allocations) {
            if (plan.selling_plan_id === checkedPlanId) {
                activeVariantPlan = plan;
            }
        }

        // update price
        document.querySelector("#productPriceNum").textContent = price(activeVariantPlan.price);
    }

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

/****************
 * Product Quantity
 */

// announce quantity and current price to assistive tech
function announceQuantity() {
    const status = document.querySelector("#productQtyStatus");
    if (!status) {
        return;
    }
    const currentPrice = document.querySelector("#productPriceNum")?.textContent.trim();
    status.textContent = `Quantity ${quantity}${currentPrice ? `, ${currentPrice} each` : ""}`;
}

// minus
document.querySelector("#productQtyMinus")?.addEventListener("click", function () {
    if (quantity === 1) {
        return;
    }
    quantity--;
    document.querySelector("#productQtyNum").textContent = quantity;
    updateProduct();
    announceQuantity();
});

// plus
document.querySelector("#productQtyPlus")?.addEventListener("click", function () {
    quantity++;
    document.querySelector("#productQtyNum").textContent = quantity;
    updateProduct();
    announceQuantity();
});

/**************
 Prime free shipping text
 ***************/
(function () {
    // calculate date of tomorrow
    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 3);
    let options = {month: 'long', day: 'numeric'};
    let tomorrowFormatted = tomorrow.toLocaleDateString('en-US', options);

    // update text
    // document.querySelector("#productPrimeShipping").textContent = `FREE Delivery as soon as Tomorrow ${tomorrowFormatted}`;
})();

/**************
 Product ATC
 ***************/

document.querySelector("#productATC").addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    // check for subscription
    const checkedPlanInput = document.querySelector("#productControls .subPlanInput:checked");
    if (checkedPlanInput) {
        // add to form data
        formData.items[0].selling_plan = parseInt(checkedPlanInput.value, 10);
    }

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();

    // announce the successful add to assistive tech (live region lives in the mini-cart)
    if (typeof announceCart === "function") {
        announceCart((window.cartStrings && window.cartStrings.itemAdded) || "Item added to your cart");
    }
});


